module.exports = __webpack_public_path__ + "static/media/checkmark_active_yl.5f114260.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/checkmark_active_yl.svg
// module id = 129
// module chunks = 0